import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/i18n";
import { Seo } from "@/components/Seo";

export default function PaymentCancel() {
    const { lang, t } = useLang();
    return (
        <div data-testid="payment-cancel-page" className="marble-bg min-h-screen pt-40 pb-24 text-center">
            <Seo lang={lang} title={`${t.payment.cancelledTitle} — TOURVOYAGERS`} />
            <div className="max-w-xl mx-auto px-5">
                <XCircle className="mx-auto text-stone-500" size={56} />
                <h1 className="mt-6 font-display text-4xl text-amber-50">{t.payment.cancelledTitle}</h1>
                <p className="mt-4 text-sm text-stone-400">{t.payment.cancelledSub}</p>
                <Link to="/esperienze" data-testid="payment-cancel-back" className="mt-10 inline-block rounded-full border border-amber-500/50 px-8 py-3 text-xs font-bold uppercase tracking-[0.14em] text-amber-200 hover:bg-amber-400/10 transition-colors">
                    {t.payment.backHome}
                </Link>
            </div>
        </div>
    );
}
